import img1 from "../../assets/Images/Event Booking/Cancel-Booking-List.png"

export default function CancelBookingList() {
    return (
        <section id="cancel-booking-list" className="space-y-16">

            {/* SECTION TITLE */}
            <div>
                <h2 className="text-xl font-semibold text-[#C9A24E] mb-3">
                    2.6 Cancel Booking List
                </h2>
                <p className="text-slate-600 max-w-3xl">
                    The Cancel Events module displays all bookings that have been canceled.
                    It provides visibility into canceled events along with their financial
                    details for record keeping and audit purposes.
                </p><br />
                <p className="text-slate-600">
                    Canceled bookings occur when an event is officially withdrawn by the
                    customer or management. Once canceled, bookings appear in this list
                    and are excluded from active scheduling and availability checks.
                </p>
            </div>

            {/* OVERVIEW */}
            {/* <section className="bg-white border-l border-[#C9A24E] p-4">
        <h3 className="text-lg font-semibold mb-2">
          Overview
        </h3>
        
      </section> */}

            {/* NAVIGATION */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Navigation & Page Behavior
                </h3>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>
                        Clicking <strong>Booking List</strong> redirects back to the main
                        Event Bookings module.
                    </li>
                    <li>
                        Only bookings marked as <strong>Canceled</strong> appear on this
                        screen.
                    </li>
                    <li>
                        Canceled events no longer block hall availability.
                    </li>
                    <li>
                        The <strong>Add New</strong> button redirects to the Add Booking form.
                    </li>
                </ul>
            </section>

            {/* TABLE */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Cancel Booking List Table
                </h3>

                <p className="text-slate-600 mb-4">
                    This table lists all canceled bookings along with relevant booking and
                    financial information.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Booking number and client name</li>
                    <li>Event type and scheduled event date</li>
                    <li>Hall portion and event slot</li>
                    <li>Total booking amount</li>
                    <li>Advance amount received</li>
                    <li>Outstanding due amount</li>
                    <li>Status marked as Canceled</li>
                </ul>

                <div className="rounded-lg p-4  mt-4">
                    <img src={img1} alt="" />
                </div>
            </section>

            {/* ACTIONS */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Available Actions
                </h3>

                <p className="text-slate-600 mb-3">
                    Canceled bookings support limited actions to preserve data integrity
                    and audit history.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>
                        <strong>Invoice</strong> – View or print the original booking invoice
                    </li>
                </ul>
            </section>

            {/* FINANCIAL NOTE */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Financial Impact of Canceled Events
                </h3>

                <p className="text-slate-600 mb-3">
                    Advance amounts for canceled bookings are recorded based on company
                    policy. EventFlow retains all financial history for transparency.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Advance amounts remain recorded for reference</li>
                    <li>No new charges can be added after cancellation</li>
                    <li>Canceled events do not appear in revenue calculations</li>
                </ul>
            </section>

            {/* WHY IMPORTANT */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Why Tracking Canceled Events Is Important
                </h3>

                <p className="text-slate-600 max-w-3xl">
                    Maintaining a clear record of canceled bookings helps prevent disputes,
                    supports audits, and provides insights into cancellations trends. It
                    ensures transparency and accountability within the system.
                </p>
            </section>

        </section>
    );
}
